/* eslint-disable no-nested-ternary */
import {
  areas,
  formatCurrency,
  formatShares,
  investmentInstruments,
  listingTypes,
  sectors,
  offerTypes,
} from 'entoro-shared';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

const formatAllCurrency = (value, currency = 'USD') => {
  // Validate currency code
  const currencyCodes = new Set(Intl.supportedValuesOf('currency'));
  const validCurrencyCode = currencyCodes.has(currency) ? currency : 'USD';

  // Format the value with respect to the specified currency
  const currencySymbols = Array.from(currencyCodes)
    .map((currencyCode) => {
      try {
        return Intl.NumberFormat('en', {
          style: 'currency',
          currency: currencyCode,
        })
          .formatToParts(0)
          .find((part) => part.type === 'currency');
      } catch (error) {
        return undefined;
      }
    })
    .filter((currencySymbol) => currencySymbol !== undefined);

  const currencySymbol = currencySymbols.find(
    (symbol) => symbol !== undefined && symbol.unit === validCurrencyCode
  );

  const formattedValue = new Intl.NumberFormat('en', {
    style: 'currency',
    currency: validCurrencyCode,
    currencyDisplay: 'symbol',
    currencySign: 'accounting',
    ...(currencySymbol && { currencyDisplay: 'code' }),
  }).format(value);

  return formattedValue;
};
const AnonOfferDetails = ({
  offer: {
    name,
    listingType,
    investmentInstrument,
    area,
    minimumInvestment,
    targetRaise,
    offerCurrency,
    valueRange,
    assetStatus,
    sharesForSale,
    sector,
    primaryObjective,
    netAcres,
    county,
    averageDailyProduction,
    typeOfOffer,
  },
  OfferName,
}) => {
  return (
    <div className='offer-details'>
      <div className='header-container'>
        <div className='black-44'>{`${OfferName}`} Details</div>
        {typeOfOffer ? (
          <Fragment>
            <div className='_16-black-label'>Type&nbsp;Of&nbsp;Offer</div>
            <div className='_26-black'>{offerTypes.getLabel(typeOfOffer)}</div>
            <br />
          </Fragment>
        ) : (
          ''
        )}
        <div>
          {listingType === 'ACQUISITIONS_AND_DIVESTITURES' ? (
            <div className='_16-black-label'>
              Primary&nbsp;Objective - {primaryObjective}
            </div>
          ) : (
            <div className='_16-black-label'>
              Sector - {sectors.getUniqueLabel(sector)}
            </div>
          )}
        </div>
      </div>
      <div className='detail-columns w-row'>
        {listingType === 'SECONDARY_SALES' && (
          <div className='detail'>
            <div className='_16-black-label'>Shares&nbsp;for&nbsp;Sale</div>
            <div className='_26-black'>{formatShares(sharesForSale)}</div>
          </div>
        )}
        {listingType === 'ACQUISITIONS_AND_DIVESTITURES' && (
          <div className='detail'>
            <div className='_16-black-label'>
              Average&nbsp;Daily&nbsp;Production
            </div>
            <div className='_26-black'>{averageDailyProduction}</div>
          </div>
        )}
        {listingType === 'ASSET_SALES' && (
          <div className='detail'>
            <div className='_16-black-label'>Value&nbsp;Range</div>
            <div className='_26-black'>{valueRange}</div>
          </div>
        )}
        {listingType !== 'SECONDARY_SALES' &&
          listingType !== 'ACQUISITIONS_AND_DIVESTITURES' &&
          listingType !== 'ASSET_SALES' && (
            <div className='detail'>
              <div className='_16-black-label'>Target&nbsp;Investment</div>
              <div className='_26-black'>
                {formatAllCurrency(targetRaise, offerCurrency)}
              </div>
            </div>
          )}
        {listingType === 'ACQUISITIONS_AND_DIVESTITURES' && (
          <div className='detail'>
            <div className='_16-black-label'>Net&nbsp;Acres</div>
            <div className='_26-black'>{formatShares(netAcres) || 'N/A'}</div>
          </div>
        )}
        {listingType === 'ASSET_SALES' && (
          <div className='detail'>
            <div className='_16-black-label'>Asset&nbsp;Status</div>
            <div className='_26-black'>{assetStatus}</div>
          </div>
        )}
        {listingType !== 'ACQUISITIONS_AND_DIVESTITURES' &&
          listingType !== 'ASSET_SALES' && (
            <div className='detail'>
              <div className='_16-black-label'>Minimum&nbsp;Investment</div>
              <div className='_26-black'>
                {formatCurrency(minimumInvestment) || 'N/A'}
              </div>
            </div>
          )}
        <div className='detail'>
          <div className='_16-black-label'>Listing Type</div>
          <div className='_26-black'>{listingTypes.getLabel(listingType)}</div>
        </div>
        {listingType === 'ACQUISITIONS_AND_DIVESTITURES' ? (
          <div className='detail'>
            <div className='_16-black-label'>County</div>
            <div className='_26-black'>{county}</div>
          </div>
        ) : (
          <div className='detail'>
            <div className='_16-black-label'>Investment Instrument</div>
            <div className='_26-black'>
              {investmentInstruments.getLabel(investmentInstrument)}
            </div>
          </div>
        )}
        <div className='detail'>
          <div className='_16-black-label'>Area</div>
          <div className='_26-black'>{areas.getLabel(area)}</div>
        </div>
      </div>
    </div>
  );
};

AnonOfferDetails.propTypes = {
  offer: PropTypes.object.isRequired,
};

export default AnonOfferDetails;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/AnonOfferDetails.js